export enum PetGenders {
    NO_GENDER = "No Gender",
    FEMALE = "Female",
    MALE = "Male",
    NEUTERED_MALE = "Neutered Male",
    SPAYED_FEMALE = "Spayed Female",
    UNKNOWN = "Unknown"
}

export enum PetGendersIds {
    NO_GENDER = 0,
    FEMALE = 1,
    MALE = 2,
    NEUTERED_MALE = 3,
    SPAYED_FEMALE = 4,
    UNKNOWN = 5
}
